import React, { useState } from "react";
import { useAuth } from "react-oidc-context";
import "./styles/landing_page.css";
import meedLogo from "../../assets/icons/meed icons -105.svg";
function LandingPage() {
  const { signinRedirect } = useAuth();
  const [isSigningIn, setIsSigningIn] = useState(false);

  const handleSignIn = () => {
    setIsSigningIn(true);
    signinRedirect().catch((err) => {
      console.error("Failed to redirect for sign-in:", err);
      setIsSigningIn(false);
    });
  };

  return (
    <div className="landing-container">
      <div className="landing-box">
        <img src={meedLogo} alt="Meed Logo" className="meed-logo" />
        <h1 className="title">Meed Internal Portal</h1>
        <p className="description">
          Please log in with your authorized account to continue.
        </p>
        <button
          onClick={handleSignIn}
          className="login-button"
          disabled={isSigningIn}
        >
          {isSigningIn ? "Redirecting..." : "Log In"}
        </button>
      </div>
    </div>
  );
}

export default LandingPage;
